/**
 * 404 — V3 §A.
 *
 * The last stub route in the app; the component it replaced is deleted, so a
 * repo-wide grep for placeholder screens now returns nothing.
 *
 * A real not-found screen, not a stub: it offers the way back rather than
 * apologising, in keeping with the §8.4 rule that every empty state offers the
 * next action.
 */

import { Link, useLocation } from 'react-router';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/shared/EmptyState';
import { useUiStore } from '@/stores/ui';

export function NotFoundPage() {
  const { pathname } = useLocation();
  const openPalette = useUiStore((s) => s.setCommandPaletteOpen);

  return (
    <div className="grid min-h-full place-items-center p-6">
      <EmptyState
        icon={<Compass className="size-6" />}
        title="No such page"
        description={`Nothing lives at ${pathname}. It may have been renamed, or the link may be stale.`}
        action={
          <div className="flex flex-wrap justify-center gap-2">
            <Link to="/my-day">
              <Button variant="primary">Go to My Day</Button>
            </Link>
            <Button variant="subtle" onClick={() => openPalette(true)}>
              Search instead
            </Button>
          </div>
        }
      />
    </div>
  );
}
